var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.121,
    height: 16.5,
    viewBox: "0 0 23.121 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7108",
    "data-name": "Path 7108",
    d: "M19.5,12q0-1.848-.138-3.662a4.006,4.006,0,0,0-3.7-3.7,48.678,48.678,0,0,0-7.324,0,4.006,4.006,0,0,0-3.7,3.7q-.025.33-.046.662M19.5,12l3-3m-3,3-3-3m-12,3q0,1.848.138,3.662a4.006,4.006,0,0,0,3.7,3.7,48.657,48.657,0,0,0,7.324,0,4.006,4.006,0,0,0,3.7-3.7q.025-.33.046-.662M4.5,12l3,3m-3-3-3,3",
    transform: "translate(-0.439 -3.75)",
    fill: "none",
    stroke: "#758ca1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.0185779d.svg";
export { ForwardRef as ReactComponent };